var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66272 5.85484C4.66272 7.359 5.26024 8.80155 6.32384 9.86515C7.38744 10.9288 8.82999 11.5263 10.3341 11.5263C11.8383 11.5263 13.2809 10.9288 14.3445 9.86515C15.4081 8.80155 16.0056 7.359 16.0056 5.85484C16.0056 4.35069 15.4081 2.90813 14.3445 1.84453C13.2809 0.780935 11.8383 0.183411 10.3341 0.183411C8.82999 0.183411 7.38744 0.780935 6.32384 1.84453C5.26024 2.90813 4.66272 4.35069 4.66272 5.85484ZM10.3341 12.6606C7.6164 12.6606 5.14479 13.4478 3.32653 14.5571C2.4191 15.1106 1.64324 15.764 1.08291 16.474C0.531645 17.1716 0.12557 18.0065 0.12557 18.8991C0.12557 19.8576 0.591763 20.613 1.26326 21.1518C1.89846 21.6623 2.7367 22.0003 3.62711 22.2362C5.41702 22.7092 7.80582 22.8691 10.3341 22.8691C12.8625 22.8691 15.2513 22.7103 17.0412 22.2362C17.9316 22.0003 18.7698 21.6623 19.405 21.1518C20.0777 20.6119 20.5427 19.8576 20.5427 18.8991C20.5427 18.0065 20.1366 17.1716 19.5854 16.4729C19.025 15.764 18.2503 15.1118 17.3418 14.556C15.5235 13.4489 13.0508 12.6606 10.3341 12.6606Z",
    fill: "#CACACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.5c6fcdd3713e0572c796ac5b6cf8e58c.svg";
export { ForwardRef as ReactComponent };